import React, { memo } from "react";
import { ADMIN_LANG } from "../../../settings";
import { OrderData, OrderOption } from "../../../types/admin";
import {Col, Table} from "react-bootstrap";

// Memoized table row component
const OrderTableRow = memo(({ option, index }: { option: OrderOption; index: number }) => (
    <tr key={index}>
        <td>{index + 1}. {option.label}</td>
        <td className='text-center text-success'>{option.correct_position}</td>
        <td className='text-center'>{option.average_position}</td>
    </tr>
));

const OrderTable = ({ optionsData }: { optionsData: OrderData }) => {
    const { options } = optionsData;

    return (
        <Col xs={12} md={6}>
        <div className='admin-card'>
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th>{ADMIN_LANG.name}</th>
                        <th className='text-center'>{ADMIN_LANG.order}</th>
                        <th className='text-center'>{ADMIN_LANG.average_order}</th>
                    </tr>
                </thead>
                <tbody>
                    {options.map((option, index) => (
                        <OrderTableRow key={index} option={option} index={index} />
                    ))}
                </tbody>
            </Table>
        </div>
        </Col>
    );
};

export default memo(OrderTable);